module.exports = __webpack_public_path__ + "img/brown.6317c353.jpg";